export default __webpack_public_path__ + "static/media/cover.ad337ddd.jpeg";